export default __webpack_public_path__ + "static/media/paper-plane.d03be6d3.svg";